module.exports = __webpack_public_path__ + "static/apple-icon-180x180-fe14df6528a6e62230cd8249c0ae0775.png";